module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEYAAAAwBAMAAABeexFrAAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAAAVUExURdcCFPX19dkCEvf399/f3////+EAEpUJczAAAAAFdFJOU+Pl5eXdOPyxPwAAADtJREFUOMtjYCACsKURAglEqVEjqCaJCDXE2JVElF1sg8o9o+YMR3NEQwmBwFE1o2pG1WBR4yhICIgAALtcQN7d3wisAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/indonesia.png
// module id = 2pUi
// module chunks = 34